let language_debug = false;

// Axios Setup

import axios from "axios";

window.axios = axios;

// Swiper Setup

import Swiper from 'swiper';

import {Autoplay, Pagination, Keyboard, Mousewheel, Navigation, EffectFade} from "swiper/modules";

Swiper.use([Navigation, Pagination, Keyboard, Mousewheel, Autoplay, EffectFade]);

window.Swiper = Swiper;

// Alpine Setup

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'

import 'swiper/css';
import 'swiper/css/effect-fade';

window.Alpine = Alpine

Alpine.plugin(collapse)
Alpine.plugin(intersect)

Alpine.start()

// Popper.js Setup

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

} catch (e) {
}

// JS Cookie setup

import Cookies from 'js-cookie';

//

import '../js/parts/subscribe';
import '../js/parts/subscribe-custom';

import '../js/parts/dk-share';

import '../js/parts/donate';

import '../js/vendor/jquery.scroll_to';
import '../js/vendor/jquery.snapscroll';

// jouele

const {Howl, Howler} = require('howler'); // for jouele
import 'ilyabirman-jouele/dist/jouele';

//

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator["msMaxTouchPoints"] > 0));
}

document.body.classList.add(isTouchDevice() ? 'is-touch' : 'no-touch');

jQuery(($) => {

    let $body = $('body');
    let current_language = $('html').attr('lang');

    try {
        let $tooltip_elements = $('[data-toggle="tooltip"]');
        if ($tooltip_elements.length) {
            $tooltip_elements.tooltip();
        }
    } catch (e) {
        console.log('error in tooltip', e);
    }

    /**
     * https://stackoverflow.com/questions/23222131/jquery-fire-action-when-element-is-in-view
     * @returns {boolean}
     */
    $.fn.isOnScreen = function () {
        let win = $(window);
        let viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };
        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();
        let bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();
        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    };

    let language_override = $body.data('language-override');
    if (language_override) {
        current_language = language_override;
        Cookies.set('language_confirmed', 'yes');
        Cookies.set('language', language_override);
    }

    if (current_language === 'ru') {
        Cookies.set('language_confirmed', 'yes');
        Cookies.set('language', language_override);
    }

    let cookie_language = Cookies.get('language');

    if (language_debug && cookie_language) {
        console.log('cookie_language', cookie_language);
    }

    let language_confirmed = Cookies.get('language_confirmed') === 'yes' || $body.hasClass('language-confirmed');

    let language_available = ($body.data('language-available') || 'en').split(',');

    if (language_debug && language_available) {
        console.log('language_available', language_available);
    }

    let suggested_language = 'en';

    if (language_available.includes('ru') && navigator.language === 'ru-RU') {
        suggested_language = 'ru';
    }

    if (cookie_language && (window.location.pathname === '' || window.location.pathname === '/')) {
        suggested_language = cookie_language;
        language_confirmed = false;
    }

    if (language_debug && suggested_language) {
        console.log('suggested_language', suggested_language);
    }

    if (!language_confirmed && suggested_language) {

        Cookies.set('language_confirmed', 'yes');

        if (current_language !== suggested_language) {
            let alternate = document.querySelector('[hreflang="' + suggested_language + '"]');
            if (alternate) {
                let href = alternate.getAttribute('href');
                if (href) {
                    window.location.href = href;
                }
            }
        }

    } else {
        Cookies.set('language', current_language);
    }

    // мастер-классы
    function image_on_hover() {
        let $image_on_hover = $('[data-image-on-hover]');
        if ($image_on_hover.length) {
            $body.on('mouseenter', '[data-image-on-hover]', function (event) {
                let image = $(event.currentTarget).data('image-on-hover');
                let target = $(event.currentTarget).data('image-on-hover-target');
                $(target).fadeOut(250, function () {
                    $(target).css('background-image', 'url(' + image + ')').fadeIn(250);
                })
            });
        }
    }

    image_on_hover();

    // куки
    function cookie_setup() {

        let cookie_agree = Cookies.get('cookie_agree');
        if (!cookie_agree) {
            $('#cookies_om_nom_nom').show();
        }

        $body.on('click', '#cookie_agree_btn', (event) => {
            event.preventDefault();
            $('#cookies_om_nom_nom').hide();
            Cookies.set('cookie_agree', '1', {expires: 365});
        })
    }

    cookie_setup();

    function yt_video_with_image_cover() {
        $body.on('click', '.ma-youtube-video-with-preview-image', function (event) {
            let video_id = $(event.currentTarget).data('yt-video-id');
            $(event.currentTarget).addClass('active');
            $(event.currentTarget).find('.ma-video-preview-image').hide();
            let $wrapper = $(event.currentTarget).find('.ma-youtube-video-embed-wrapper');
            $wrapper.show();
            $wrapper.html('<iframe class="embed-responsive-item" src="https://www.youtube.com/embed/' + video_id + '?autoplay=1&loop=0&rel=0&wmode=transparent&listType=user_uploads" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" style="border:0" allowfullscreen></iframe>');
        });
    }

    yt_video_with_image_cover();

    function custom_video_with_image_cover() {
        $body.on('click', '.ma-video-with-preview-image', function (event) {
            $(event.currentTarget).addClass('active');
            $(event.currentTarget).find('.ma-video-preview-image').hide();
            let $wrapper = $(event.currentTarget).find('.ma-video-embed-wrapper');
            $wrapper.show();
        });
    }

    custom_video_with_image_cover();

    function vimeo_video_with_image_cover() {
        $body.on('click', '.ma-vimeo-video-with-preview-image', function (event) {
            const video_id = event.currentTarget.dataset.vimeoVideoId;
            event.currentTarget.classList.add('active');
            event.currentTarget.querySelector('.ma-video-preview-image').style.display = 'none';

            let wrapper = event.currentTarget.querySelector('.ma-vimeo-video-embed-wrapper');
            wrapper.style.display = "block";

            const iframe = document.createElement('iframe');
            const script = document.createElement('script');

            iframe.src = `https://player.vimeo.com/video/${video_id}?autoplay=1&title=0&byline=0&portrait=0`;
            iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0';
            iframe.allow = 'autoplay; fullscreen';
            iframe.allowFullscreen = true;

            script.src = 'https://player.vimeo.com/api/player.js';

            wrapper.innerHTML = '';
            wrapper.appendChild(iframe);
            wrapper.appendChild(script);
        });
    }

    vimeo_video_with_image_cover();

    let $maMediaGridSliders = $('.ma-media-grid-slider');
    if ($maMediaGridSliders.length) {
        $maMediaGridSliders.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-media-grid-slider-wrapper');
            let prev = $wrapper.find('.ma-media-grid-slider-nav-prev')[0];
            let next = $wrapper.find('.ma-media-grid-slider-nav-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView: 2,
                autoHeight: true,

                observer: true,
                observeParents: true,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

                breakpoints: {
                    992: {
                        slidesPerView: 3,
                    }
                },

            });

            swiper.update();
        });
    }

    let $maMediaGridSlidersTwo = $('.ma-media-grid-slider-two');
    if ($maMediaGridSlidersTwo.length) {
        $maMediaGridSlidersTwo.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-media-grid-slider-wrapper');
            let prev = $wrapper.find('.ma-media-grid-slider-nav-prev')[0];
            let next = $wrapper.find('.ma-media-grid-slider-nav-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView: 2,
                autoHeight: true,

                observer: true,
                observeParents: true,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

                breakpoints: {
                    768: {
                        slidesPerView: 1,
                    },
                    1024: {
                        slidesPerView: 2,
                    }
                },


            });

            swiper.update();
        });
    }

    let $maFrontPageSlider = $('.ma-front-page-slider');
    if ($maFrontPageSlider.length) {
        $maFrontPageSlider.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-slider-nav-wrapper');
            let prev = $wrapper.find('.ma-front-page-slider-nav-prev')[0];
            let next = $wrapper.find('.ma-front-page-slider-nav-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1,
                autoHeight: true,

                observer: true,
                observeParents: true,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

            });

            swiper.update();
        });
    }

    let $maFullWidthSliders = $('.ma-full-width-slider');
    if ($maFullWidthSliders.length) {
        $maFullWidthSliders.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-slider-nav-wrapper');
            let prev = $wrapper.find('.ma-full-width-slider-nav-prev')[0];
            let next = $wrapper.find('.ma-full-width-slider-nav-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1,
                autoHeight: true,

                observer: true,
                observeParents: true,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

            });

            swiper.update();
        });
    }

    let $maMediaLayoutSlidersTwo = $('.ma-media-layout-slider-two');
    if ($maMediaLayoutSlidersTwo.length) {
        $maMediaLayoutSlidersTwo.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-slider-nav-wrapper');
            let prev = $wrapper.find('.ma-full-width-slider-nav-prev')[0];
            let next = $wrapper.find('.ma-full-width-slider-nav-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1,
                autoHeight: true,

                observer: true,
                observeParents: true,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

                breakpoints: {
                    992: {
                        slidesPerView: 2,
                    }
                },

            });

            swiper.update();
        });
    }

    let $maGallerySlider = $('.ma-gallery-slider');
    if ($maGallerySlider.length) {
        $maGallerySlider.each((index, slider) => {

            let $wrapper = $(slider).closest('.ma-gallery-slider-wrapper');
            let prev = $wrapper.find('.ma-gallery-slider-prev')[0];
            let next = $wrapper.find('.ma-gallery-slider-next')[0];

            let swiper = new Swiper('#' + $(slider).attr('id'), {

                slidesPerView: 'auto',
                spaceBetween: 30,
                loop: false,

                // Navigation arrows
                navigation: {
                    prevEl: prev,
                    nextEl: next,
                },

            });

            swiper.update();
        });
    }

    let $historyYearSlider = $('.history-year-slider');
    if ($historyYearSlider.length) {

        let swiper = new Swiper('.history-year-slider', {
            slidesPerView: 'auto',
            loop: false,
        });

        swiper.slideTo($('.history-year-slider .active').index(), 500, false);

    }

    function ma_async_attachments_loader() {
        let ma_post_async_container = document.getElementById('ma_post_async_container');
        if (!ma_post_async_container) {
            return false;
        }

        let loading_text = ma_post_async_container.getAttribute('data-loading-text');

        let ma_ajax = window['ma_ajax'];
        let post_id = ma_ajax.post_id;
        let nonce = ma_ajax.nonce;

        let formData = new FormData();
        formData.append('post_id', post_id);
        formData.append('nonce', nonce);

        let loading_text_timeout = setTimeout(function () {
            ma_post_async_container.innerHTML = '<div class="fz-14 fz-md-18 pb-5 text-muted">' + loading_text + '</div>';
        }, 1000);

        axios.post(ma_ajax.url + '?action=post_attachments', formData, {

            headers: {'Content-Type': 'multipart/form-data'},

        }).then((response) => {

            if (typeof loading_text_timeout !== "undefined") {
                clearTimeout(loading_text_timeout);
            }

            ma_post_async_container.innerHTML = response.data;

        }).catch((error) => {
            console.log(error.response);
        });
    }

    ma_async_attachments_loader();


    /**
     * Load previous category page
     */
    let infiniteScrollLoad = (older_entries_link) => {

        console.log('infiniteScrollLoad');

        if (window.infiniteScrollLoading) return;
        window.infiniteScrollLoading = true;
        if (!older_entries_link) {
            console.log('older_entries_link', older_entries_link);
            return;
        }

        let href = older_entries_link.href;
        if (!href) {
            return;
        }

        older_entries_link.classList.add('ma-btn-disabled');

        console.log('axios loading ' + href);

        axios.get(href).then((response) => {

            let $data = $(response.data);
            let $content = $data.find('.ma-media-layout__wrapper');
            let $nav = $data.find('#older_entries');
            let html = $content.html().trim();
            if (html.length === 0) {
                $('.ma-invisible-pagination').addClass('invisible');
            }

            $body.find('.ma-media-layout__wrapper').append(html);
            if ($nav.html()) {
                $body.find('#older_entries').html($nav.html());
            } else {
                $body.find('#older_entries').html('');
            }

            if (typeof window['ticketDealer'] !== 'undefined') {
                if (typeof window['ticketDealer'].scan === 'function') {
                    window['ticketDealer'].scan();
                    console.log('ticketDealer.scan');
                }
            }

            balanced_text();
            window.infiniteScrollLoading = false;
            older_entries_link.classList.remove('ma-btn-disabled');

        }).catch((error) => {

            console.log('axios infinite scroll loading error');
            console.log(error);
            older_entries_link.classList.remove('ma-btn-disabled');
            window.infiniteScrollLoading = false;

        });

    }

    function header_absolute(header, top) {
        header = header || document.getElementById('site-header');
        if (!header) {
            return;
        }
        top = top || 0;
        if (!header) return;
        if (header.classList.contains('position-absolute')) return;
        header.classList.remove('fixed-top');
        header.classList.add('position-absolute');
        header.style.top = top + 'px';
    }

    function header_fixed(header) {
        header = header || document.getElementById('site-header');
        if (!header) {
            return;
        }
        if (header.classList.contains('fixed-top')) {
            return;
        }
        header.classList.add('fixed-top');
        header.classList.remove('position-absolute');
        header.style.top = 0 + 'px';
    }

    function fixedHeaderWithLimit() {

        let header = document.getElementById('site-header');
        if (!header) {
            return;
        }

        let endOfFixedHeaderElements = document.getElementsByClassName('end-of-fixed-header');
        if (!endOfFixedHeaderElements.length) {
            header_absolute(header);
            return;
        }

        let end_of_fixed_header_px = endOfFixedHeaderElements[0].offsetTop;

        // https://stackoverflow.com/questions/31712287/get-scroll-position-in-javascript
        let scroll_pos_px = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
        let site_main_scroll = document.querySelector('.scroll-snap-wrapper');
        if (site_main_scroll && $(site_main_scroll).css('scroll-snap-type') !== 'none') {
            scroll_pos_px = site_main_scroll.scrollTop;
        }

        if (scroll_pos_px > end_of_fixed_header_px) {
            header_absolute(header, end_of_fixed_header_px);
        } else {
            header_fixed(header);
        }

        let endOfFixedLogoElements = document.getElementsByClassName('end-of-fixed-logo');
        if (endOfFixedLogoElements.length) {
            let end_of_fixed_logo_px = endOfFixedLogoElements[0].offsetTop;
            if (scroll_pos_px + 200 > end_of_fixed_logo_px) {
                $body.addClass('logo-hidden');
            } else {
                $body.removeClass('logo-hidden');
            }
        }

    }

    function balanced_text() {
        $('.balance-text').each(function () {
            $(this).css('width', '');
            let currentHeight = $(this).height();
            let thisHeight = currentHeight;
            let newWidth = $(this).width();
            let testWidth = newWidth;
            // Try shrinking width until height changes
            while (thisHeight === currentHeight && testWidth > 0) {
                testWidth = newWidth - 10;
                $(this).width(testWidth);
                thisHeight = $(this).height();
                if (thisHeight === currentHeight) {
                    newWidth = testWidth;
                } else {
                    break;
                }
            }
            $(this).width(newWidth);
            $(this).addClass('balanced-text');
        });
    }

    function modify_wp_galleries() {
        let $galleries = $('.gallery');

        $galleries.each((index, gallery) => {
            modify_wp_gallery(gallery, index);
        });

        init_swiper_galleries();
    }

    modify_wp_galleries();

    function modify_wp_gallery(gallery, index) {

        let svg_left = '<svg width="13" height="84" viewBox="0 0 13 84" fill="none"\n' +
            '                               xmlns="http://www.w3.org/2000/svg">\n' +
            '                            <path d="M12 83L2 42L12 1" stroke="#C2040F" stroke-width="2"/>\n' +
            '                          </svg>';

        let svg_right = '<svg width="13" height="84" viewBox="0 0 13 84" fill="none"\n' +
            '                               xmlns="http://www.w3.org/2000/svg">\n' +
            '                            <path d="M1 1L11 42L0.999996 83" stroke="#C2040F" stroke-width="2"/>\n' +
            '                          </svg>';

        $(gallery).addClass('swiper-wrapper');
        $(gallery).find('.gallery-item').addClass('swiper-slide');
        $(gallery).wrap('<div class="swiper-container swiper-gallery" id="swiper_gallery_' + index + '"></div>');
        $(gallery).parent().wrap('<div class="container"></div>');
        $(gallery).parent().parent().wrap('<div class="swiper-overflow-container swiper-gallery-content"></div>');
        $(gallery).parent().parent().parent().wrap('<div class="swiper-gallery-root py-3"></div>')
        $(gallery).parent().parent().parent().after('<div class="swiper-gallery-height"></div>');
        $(gallery).find('p').remove();
        $(gallery).after('<div class="swiper-button-prev">' + svg_left + '</div><div class="swiper-button-next">' + svg_right + '</div>');
    }

    function init_swiper_galleries() {
        let $gallerySliders = $('.swiper-gallery');
        $gallerySliders.each((index, slider) => {
            new Swiper('#' + $(slider).attr('id'), {
                direction: 'horizontal',
                loop: false,
                freeMode: true,
                slidesPerView: "auto",
                spaceBetween: 30,

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        });
    }

    function init_swiper_records() {
        let $recordSliders = $('.ma-records-slider');
        $recordSliders.each((index, slider) => {
            new Swiper('#' + $(slider).attr('id'), {
                direction: 'horizontal',
                loop: false,
                slidesPerView: 1.5,
                spaceBetween: 30,
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    1230: {
                        slidesPerView: 4,
                    }
                },

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        });
    }

    init_swiper_records();


    function replace_wp_gallery_captions() {

        let $captions = $('.gallery .wp-caption-text');

        $captions.each((index, caption) => {

            let text = $(caption).html();

            $(caption).addClass('mb-0');

            let new_html = '<a href="#"\n' +
                ' class="text-decoration-none image-alt-text-right-bottom fz-14 text-light px-2 py-1"\n' +
                ' data-toggle="tooltip"\n' +
                ' data-placement="left"\n' +
                ' title="' + text + '">\n' +
                ' <span class="sr-only">' + text + '</span>\n' +
                ' <span>Ⓘ</span> </a>'

            $(caption).html(new_html);

            $(caption).find('a').tooltip();

        });

    }

    replace_wp_gallery_captions();


    function history_img_alt_text() {

        let $images = $('.ma-page-history p>img');

        $images.each((index, img) => {

            let alt = $(img).attr('alt');
            if (alt === '') {
                return;
            }

            $(img).parent('p').addClass('position-relative');
            $(img).after('<a href="#" class="text-decoration-none image-alt-text-right-bottom fz-14 text-light px-2 py-1" data-toggle="tooltip" data-placement="left" title="' + alt + '"> <span>Ⓘ</span> </a>');
            $(img).parent('p').find('a').tooltip();

        });
    }

    history_img_alt_text();


    function ma_event_in_residency_stripe() {
        let notification = document.querySelector('.ma-event-in-residency-stripe');
        if (notification === null) {
            return;
        }

        let event_id = notification.getAttribute('data-event-id');

        let notification_dismissed = Cookies.get('dismiss_event_notification_' + event_id);
        if (!notification_dismissed) {
            notification.classList.add('active');
        }

        $(notification).on('click', '.ma-event-in-residency-dismiss', function (event) {
            event.preventDefault();
            notification.classList.remove('active');
            Cookies.set('dismiss_event_notification_' + event_id, 1, {expires: 7});
        });
        if (notification_dismissed) {
            return;
        }

        new Swiper('#single_event_notification_swiper', {
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            speed: 10000,
            grabCursor: false,
            mousewheelControl: false,
            keyboardControl: false,
            direction: 'horizontal',
            slidesPerView: 'auto',
            loop: true,
        });
    }

    ma_event_in_residency_stripe();

    /**
     * https://usefulangle.com/post/113/javascript-detecting-element-visible-during-scroll#:~:text=To%20know%20whether%20the%20element%20is%20fully%20visible%20in%20viewport,window.
     */
    function infiniteScrollHandler() {

        let older_entries = document.getElementById('older_entries');
        if (!older_entries) {
            return;
        }

        if (older_entries.classList.contains('paged-manual')) {
            $body.on('click', '.paged-manual#older_entries', function (event) {
                event.preventDefault();
                let older_entries_link = older_entries.getElementsByTagName('a');
                infiniteScrollLoad(older_entries_link[0]);
            });
        }

        if (!older_entries.classList.contains('paged-auto')) {
            return;
        }

        let older_entries_link = older_entries.getElementsByTagName('a');
        if (!older_entries_link.length) {
            return;
        }

        let position = older_entries_link[0].getBoundingClientRect();
        if (!window.infiniteScrollLoading) {
            if (position.top >= 0 && position.bottom <= window.innerHeight) {
                infiniteScrollLoad(older_entries_link[0]);
            }
        }
    }

    function init_ma_event_accordion() {

        let $accordion = $('.ma-events-accordion');
        if (!$accordion.length) {
            return;
        }

        $body.on('click', '.ma-events-accordion .ma-event-row a.stretched-link', function (event) {

            $('.ma-event-row').addClass('ma-event-row-pre-collapse');

            let $link = $(event.currentTarget);

            let $row = $link.closest('.ma-event-row');

            if (!$row.hasClass('active') && !$row.find('.js-accordion-program-text').data('empty')) {
                event.preventDefault();
                $row.addClass('active');

            }

            $row.removeClass('ma-event-row-pre-collapse');

            let $accordion = $row.closest('.ma-events-accordion');
            $accordion.find('.ma-event-row-pre-collapse').removeClass('active');

        });

        $body.on('click', '.ma-events-accordion .ma-event-row .accordion-plus-cross', function (event) {

            $('.ma-event-row').addClass('ma-event-row-pre-collapse');

            let $trigger = $(event.currentTarget);

            let $row = $trigger.closest('.ma-event-row');

            $row.removeClass('ma-event-row-pre-collapse');

            $row.toggleClass('active');

            let $accordion = $row.closest('.ma-events-accordion');
            $accordion.find('.ma-event-row-pre-collapse').removeClass('active');
        });

    }

    init_ma_event_accordion();

    function stupidSliderWidthFix() {

        let w = $(window).width();

        if (w > 767) {
            return;
        }

        let new_width = (w * 1.7) / 2;

        $('.ma-media-grid-slider .swiper-slide').width(new_width);
    }

    stupidSliderWidthFix();

    window.infiniteScrollLoading = false;

    window.addEventListener('scroll', function () {

        infiniteScrollHandler();
        fixedHeaderWithLimit();
    });

    window.addEventListener('resize', function () {

        fixedHeaderWithLimit();
        stupidSliderWidthFix();
        setTimeout(() => {
            balanced_text();
        }, 100);
    });

    let site_main_scroll = document.querySelector('.scroll-snap-wrapper');
    if (site_main_scroll) {
        site_main_scroll.focus();
        site_main_scroll.addEventListener('scroll', function () {
            infiniteScrollHandler();
            fixedHeaderWithLimit();
        });
    }

    infiniteScrollHandler();
    fixedHeaderWithLimit();
    balanced_text();

    let stickyElement = document.getElementById("sticky");
    if (stickyElement) {

        maStickyElement();
        window.onscroll = function () {
            maStickyElement()
        };

        // Add the sticky class to the navbar when you reach its scroll position.
        // Remove "sticky" when you leave the scroll position
        function maStickyElement() {

            let stickyElement_height = stickyElement.clientHeight;

            let event_sticky_trigger_show = document.getElementById("event_sticky_trigger_show");
            let event_sticky_trigger_hide = document.getElementById("event_sticky_trigger_hide");
            let event_sticky_trigger_dark = document.getElementById("event_sticky_trigger_dark");

            let event_sticky_trigger_show_y = 99999;
            if (event_sticky_trigger_show) {
                event_sticky_trigger_show_y = event_sticky_trigger_show.offsetTop;
            }

            let event_sticky_trigger_hide_y = 0;
            if (event_sticky_trigger_hide) {
                event_sticky_trigger_hide_y = event_sticky_trigger_hide.offsetTop;
            }

            let event_sticky_trigger_dark_y = 99999;
            if (event_sticky_trigger_dark) {
                event_sticky_trigger_dark_y = event_sticky_trigger_dark.offsetTop;
            }

            let client_height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
            if (!client_height) return;

            let client_scrollTop = document.documentElement.scrollTop;
            let client_scrollBottom = client_scrollTop + client_height;

            if (client_scrollBottom > event_sticky_trigger_hide_y) {
                stickyElement.classList.remove("active");
            } else if (client_scrollTop > event_sticky_trigger_show_y) {
                stickyElement.classList.add("active");
            } else {
                stickyElement.classList.remove("active");
            }

            if (client_scrollBottom > event_sticky_trigger_dark_y + stickyElement_height) {
                stickyElement.classList.add("bg-dark0");
                stickyElement.classList.remove("bg-dark2");
            } else {
                stickyElement.classList.add("bg-dark2");
                stickyElement.classList.remove("bg-dark0");
            }

        }
    }

    function loadAjaxEventsCalendar($wrapper, manual) {

        manual = manual || false;

        $wrapper.addClass('ma-calendar-loading');

        let month = $wrapper.data('month');
        let year = $wrapper.data('year');
        let event_date = $wrapper.data('event-date');
        let params = new URLSearchParams();
        let ma_ajax = window['ma_ajax'];

        params.append('action', 'events_calendar');
        params.append('nonce', ma_ajax.nonce);
        params.append('lang', ma_ajax.lang);

        params.append('month', month);
        params.append('year', year);
        params.append('event_date', event_date);

        if (manual) {
            params.append('manual', '1');
        }

        axios.post(ma_ajax.url, params)
            .then(
                (response) => {
                    console.log(response);

                    $wrapper.html(response.data.html);
                    $wrapper.removeClass('ma-calendar-loading');
                },
                (error) => {
                    console.log(error);
                }
            );
    }

    let $maAjaxEventsCalendar = $('.ma-ajax-events-calendar');
    if ($maAjaxEventsCalendar.length) {

        $body.on('click', '.ma-calendar-month-prev', function (event) {
            event.preventDefault();
            let month = parseInt($maAjaxEventsCalendar.data('month')) - 1;
            let year = parseInt($maAjaxEventsCalendar.data('year'));
            if (month === 0) {
                month = 12;
                year--;
            }
            $maAjaxEventsCalendar.data('month', month);
            $maAjaxEventsCalendar.data('year', year);
            loadAjaxEventsCalendar($maAjaxEventsCalendar, true);
        });

        $body.on('click', '.ma-calendar-month-next', function (event) {
            event.preventDefault();
            let month = parseInt($maAjaxEventsCalendar.data('month')) + 1;
            let year = parseInt($maAjaxEventsCalendar.data('year'));
            if (month === 13) {
                month = 1;
                year++;
            }
            $maAjaxEventsCalendar.data('month', month);
            $maAjaxEventsCalendar.data('year', year);
            loadAjaxEventsCalendar($maAjaxEventsCalendar, true);
        });
    }

    function updateInticketsButton(button, data) {

        let btn_show_id = $(button).data('show-id');
        let lang_sold_out = $(button).data('lang-sold-out');

        data.forEach((show_data) => {
            if (show_data["show_id"].toString() !== btn_show_id.toString()) {
                return;
            }
            if (!show_data["sold_out"]) {
                return;
            }
            $(button).addClass('ma-btn-disabled');
            $(button).find('.js-btn-caption').html(lang_sold_out);
        });

    }

    function inticketsButtonsAsync() {

        let buttons = document.getElementsByClassName('intickets-btn-async');
        if (!buttons.length) {
            return;
        }

        let ma_ajax = window['ma_ajax'];
        let api_key = ma_ajax["intickets_api_key"];
        if (!api_key) {
            return;
        }

        $.ajax({
            url: 'https://api.intickets.ru/widget/v1/shows',
            headers: {'Authorization': 'Bearer ' + api_key},
            success: function (data) {
                for (let i = 0; i < buttons.length; i++) {
                    updateInticketsButton(buttons.item(i), data);
                }
            }
        });
    }

    inticketsButtonsAsync();

    $(document).ready(function () {
        $(window).scroll(function () {
            let $h_scroll_animation = $('.h-scroll.animation-scroll-preview');
            if ($h_scroll_animation.length && $h_scroll_animation.isOnScreen()) {
                if (!$h_scroll_animation.hasClass('animation-shown')) {
                    $h_scroll_animation.addClass('animation-shown');
                    setTimeout(() => {
                        $h_scroll_animation.animate({scrollLeft: 100}, 300);
                    }, 300);
                    setTimeout(() => {
                        $h_scroll_animation.animate({scrollLeft: 0}, 300);
                    }, 600);
                    setTimeout(() => {
                        $h_scroll_animation.animate({scrollLeft: 100}, 300);
                    }, 900);
                    setTimeout(() => {
                        $h_scroll_animation.animate({scrollLeft: 0}, 300);
                    }, 1200);
                }
            }
        });
    });

    $body.on('click', '.ma-secondary-menu a', function () {
        let $wrapper = $('.ma-secondary-menu').parent();
        $('.tab-pane .balance-text').css('width', 'auto');
        $('html, body').animate({
            scrollTop: $wrapper.offset().top
        }, 500, function () {
            balanced_text();
            setTimeout(function () {
                balanced_text();
            }, 250);
        });
    });

    let lastScrollTop = 0;

    window.addEventListener("scroll", function () {
        let st = document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            onScrollDown();
        } else {
            onScrollUp();
        }
        lastScrollTop = st <= 0 ? 0 : st;
    }, false);

    function onScrollDown() {
        $body.addClass('scroll-down').removeClass('scroll-up');
    }

    function onScrollUp() {
        $body.addClass('scroll-up').removeClass('scroll-down');
    }


    $body.on('click', '.scroll-to-anchor', function (event) {

        let target = $(event.target).attr('href');

        $('html,body').animate({scrollTop: $(target).offset().top}, 'slow');

    });

    $body.on('click', '.scroll-to-data-target', function (event) {

        event.preventDefault();

        let target = $(event.target).attr('data-scroll-target');

        let offset = 0;
        if ($(event.target).is('[data-scroll-offset]')) {
            offset = parseInt($(event.target).attr('data-scroll-offset'));
        }

        $('html,body').animate({scrollTop: $(target).offset().top + offset}, 'slow');

    });

});

function toggleable_wp_admin_bar() {

    let wp_admin_bar_toggle = document.getElementById('toggle_admin_bar');
    if (!wp_admin_bar_toggle) {
        return false;
    }

    let wp_admin_bar = document.getElementById('wpadminbar');
    if (!wp_admin_bar) {
        //console.log('wp admin bar not found')
        return false;
    }

    let html = document.documentElement;
    let hide_wp_admin_bar_cookie = Cookies.get('hide_wp_admin_bar');

    if (hide_wp_admin_bar_cookie) {
        wp_admin_bar.style.display = 'none';
        html.classList.add('ma-wp-admin-hidden');
    }

    wp_admin_bar_toggle.addEventListener('click', function (event) {
        event.preventDefault();
        if (wp_admin_bar.style.display === 'none') {
            wp_admin_bar.style.display = '';
            html.classList.remove('ma-wp-admin-hidden');
            Cookies.set('hide_wp_admin_bar', 0);
        } else {
            wp_admin_bar.style.display = 'none';
            html.classList.add('ma-wp-admin-hidden');
            Cookies.set('hide_wp_admin_bar', 1);
        }
    });

}

document.addEventListener('DOMContentLoaded', function () {
    toggleable_wp_admin_bar();
});

jQuery(function ($) {

    let $html = $('html');
    let $body = $('body');
    let $menu = $('.ma-main-menu-header-v2 ul.menu');
    let $dropdown = $('.ma-main-menu-dropdown-content');
    let $dropdown_link = $('.ma-main-menu-dropdown-link');

    if ($menu.length && $dropdown.length && $dropdown_link.length) {

        updateMenu($menu, $dropdown, $dropdown_link);
        window.addEventListener('resize', function () {

            updateMenu($menu, $dropdown, $dropdown_link);
        });
        $body.on('click', '.ma-main-menu-dropdown-link', function () {

            updateMenu($menu, $dropdown, $dropdown_link);

            $dropdown.toggleClass('active');

            if ($dropdown.hasClass('active')) {
                $dropdown_link.addClass('active');
                $html.addClass('menu-is-open');
            } else {
                $dropdown_link.removeClass('active');
                $html.removeClass('menu-is-open');
            }
        });
    }

    init_submenu_mobile_nav();
});

function updateMenu($menu, $dropdown, $dropdown_link) {
    let dropdownItemsCount = 0;
    let offsetTop = $menu.offset().top;
    $dropdown.empty();
    $menu.children().each(function (i, a) {
        if (!$(a).is(':visible') || $(a).offset().top > offsetTop) {
            $dropdown.append($(a).clone());
            dropdownItemsCount++;
        }
    });

    if (dropdownItemsCount === 0) {
        $dropdown_link.addClass('d-none');
        $dropdown.addClass('d-none');

    } else {
        $dropdown_link.removeClass('d-none');
        $dropdown.removeClass('d-none');
    }

    let $siteHeader2background = $('#site-header-v2-background');
    if ($siteHeader2background.length) {
        let $siteHeader2container = $('#site-header-v2-container');
        $siteHeader2background.css('height', $siteHeader2container[0].clientHeight + 'px');
    }
}

function init_submenu_mobile_nav() {

    let ma_submenu_nav = document.getElementById('ma_submenu_nav');
    if (!ma_submenu_nav) {
        return;
    }

    let $active_submenu_item = $(ma_submenu_nav).find('li.current_page_item');

    let $prev_submenu_item = $active_submenu_item.prev('li');
    let $next_submenu_item = $active_submenu_item.next('li');

    let submenuMobileNavPrev = $('#submenu_mobile_nav_prev');
    let submenuMobileNavNext = $('#submenu_mobile_nav_next');

    if ($prev_submenu_item.length) {
        submenuMobileNavPrev.html($prev_submenu_item.html());
        let $link = submenuMobileNavPrev.find('a');
        $link.html('« ' + $link.html());
        $link.addClass('text-white text-decoration-none');
    }
    if ($next_submenu_item.length) {
        submenuMobileNavNext.html($next_submenu_item.html());
        let $link = submenuMobileNavNext.find('a');
        $link.html($link.html() + ' »');
        $link.addClass('text-white text-decoration-none');
    }

}